import * as React from 'react'
import { renderLoadedText } from 'src/share/utils/placeholders';
import { IconTooltip } from 'src/share/components/IconTooltip/IconTooltip';
import { timestampToDateTimeString } from 'src/share/utils/utils';

export const getAlertStatusColor = (alertStatus: string) => {
  const status = {
    Active: 'green',
    Expired: 'gray',
    Stopped: 'yellow',
    Sent: 'blue',
    Error: 'red',
    Warning: 'orange'
  };
  return status[alertStatus];
}

export interface IAlertHistoryRowProps {
  alert?: any;
  loading: boolean;
  index?: number;
}

export const AlertHistoryRow = ({ index, loading, alert = {} }: IAlertHistoryRowProps) =>
  alert &&
  <div className="alert-record">
    <div className="alert-record__info">
      <h5>Alert ID:</h5>
      <p>{renderLoadedText(alert.id, !loading, 1, 20)}</p>
    </div>
    <div className="alert-record__info">
      <h5>Status:</h5>
      {
        alert.status === 'Error' || alert.status === 'Warning' ?
          <p>{renderLoadedText(
            <>
              <IconTooltip
                icon={` circle bg-${getAlertStatusColor(alert.status)}`}
                id={`alert-${alert.id}-${index}`}
                placement="top" autoHide={true}
                text={alert.status === 'Warning' ? 'We didn’t receive any response from FIA' :
                  !alert.errorMessage ? 'Unknown' : alert.errorMessage} />{alert.status}
            </>, !loading, 1, 20)} </p> :
          <p>{renderLoadedText(<><span className={`circle bg-${getAlertStatusColor(alert.status)}`} /> {alert.status}</>, !loading, 1, 20)} </p>
      }
    </div>
    <div className="alert-record__info">
      <h5>Created At:</h5>
      <p>{renderLoadedText(timestampToDateTimeString(alert.createdAt), !loading, 1, 40)}</p>
    </div>
  </div>



// WEBPACK FOOTER //
// ./src/modules/Alert/ControlCenter/components/AlertHistoryRow.tsx